// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"5f620e89","133":"9bbd0c60","182":"fd4ea05d"}[chunkId] + ".chunk.js";
};